/** @jsxImportSource ./simboluri-jsx */
import { useState } from "react";
import { useT, useTn } from "../i18n";
import type { Cheie } from "../i18n";
import { AvertismentMetoda } from "./tipuri";

// Avertismentele de METODĂ (M1…M12) — altceva decât avertismentele de calcul.
// Ele nu spun „ceva a ieșit prost", ci „aici motorul face ce face structuristul
// în practică, iar normativul cere altceva". Fiecare arată, una lângă alta,
// varianta implementată și cerința normativă, plus impactul numeric măsurat pe
// proiectul curent și LOCUL comutatorului. „Locul", nu „preferința": din
// niciunul dintre comutatoarele astea nu e câmp de formular —
// sunt constante ale metodei sau decizii ale solverului.
//
// STRÂNSE implicit. Desfășurate, cele 11 puncte ale
// Pasului 6 ocupau 1.974 px — o treime din pagină, între tabelul verificărilor
// și desen. Ce se vede acum fără clic e LISTA lor, cu impactul pe proiectul
// curent pe un rând; textul complet (implementat vs normativ) se deschide
// punct cu punct, sau tot odată din „desfășoară-le pe toate".
//
// Punctul cu impact real rămâne vizibil ca atare: rândurile de «atenție» sunt
// marcate, ca strângerea să nu ascundă tocmai ce contează.

// Intro-ul și eticheta severității se schimbă cu locul: la Pasul 6 «atenție»
// înseamnă că metoda biroului diverge de normativ pe proiectul acesta, la
// Pasul 8 că lipsește o solicitare (omisiunea e de partea neacoperitoare).
export default function AvertismenteMetoda({
  avertismente,
  titlu = "struct.am.titlu",
  intro = "struct.am.intro",
  numeAtentie = "struct.am.nume_atentie",
}: {
  avertismente: AvertismentMetoda[];
  titlu?: Cheie;
  intro?: Cheie;
  numeAtentie?: Cheie;
}) {
  const t = useT();
  const tn = useTn();
  const [deschise, setDeschise] = useState<Set<string>>(new Set());
  if (!avertismente || avertismente.length === 0) return null;
  const atentie = avertismente.filter((a) => a.severitate === "atentie").length;
  const toateDeschise = deschise.size === avertismente.length;

  const comuta = (cod: string) =>
    setDeschise((s) => {
      const n = new Set(s);
      if (n.has(cod)) n.delete(cod);
      else n.add(cod);
      return n;
    });

  return (
    <div className="st-findings am-wrap">
      <h3>
        {t(titlu)}
        <span className="sg-muted am-count">
          {" "}
          {tn("struct.am.puncte#n", avertismente.length)}
          {atentie > 0 &&
            t("struct.am.din_care", { n: atentie, nume: t(numeAtentie) })}
        </span>
        <button
          className="ex-toggle am-toate"
          onClick={() =>
            setDeschise(
              toateDeschise
                ? new Set()
                : new Set(avertismente.map((a) => a.cod))
            )
          }
        >
          {toateDeschise ? t("struct.am.stringe") : t("struct.am.desfasoara")}
        </button>
      </h3>
      <p className="sg-muted am-intro">{t(intro)}</p>
      {avertismente.map((a) => {
        const deschis = deschise.has(a.cod);
        return (
          <div key={a.cod} className={`am-item am-${a.severitate}`}>
            <button className="am-head am-head-buton"
                    aria-expanded={deschis}
                    onClick={() => comuta(a.cod)}>
              <span className="am-sageata">{deschis ? "▾" : "▸"}</span>
              <span className="am-cod">{a.cod}</span>
              <strong>{a.titlu}</strong>
              {a.preferinta && (
                <span className="am-pref"
                      title={t("struct.am.comutator_titlu")}>
                  {t("struct.am.comutator")} <code>{a.preferinta}</code>
                </span>
              )}
            </button>
            {/* impactul pe proiectul CURENT rămâne vizibil strâns: e singura
                parte care se schimbă de la un proiect la altul */}
            <div className="am-impact">
              <span className="am-eticheta">{t("struct.am.impact")}</span> {a.impact}
            </div>
            {deschis && (
              <div className="am-cols">
                <div>
                  <span className="am-eticheta">{t("struct.am.implementat")}</span>
                  <div>{a.metoda}</div>
                </div>
                <div>
                  <span className="am-eticheta">{t("struct.am.normativ")}</span>
                  <div>{a.normativ}</div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
